import * as BalanceSheetService from '../services/BalanceSheetService';
import * as ReconcillitionService from '../services/ReconcillitionService';
import React from 'react';
import { toast } from "react-toastify";

export const GET_BALANCESHEET_DETAILS = "GET_BALANCESHEET_DETAILS";
export const GET_ARCHIVED_DETAILS = "GET_ARCHIVED_DETAILS";
export const UPDATE_CUSTOM_FILEDS ="UPDATE_CUSTOM_FILEDS";
export const GET_GLReviewLastQueterDate ="GET_GLReviewLastQueterDate";
export const GET_EDIT_ARCHIED_DATA ="GET_EDIT_ARCHIED_DATA";
export const GET_BSACCOUNTS_RECONCILE = "GET_BSACCOUNTS_RECONCILE";
export const RELOAD = 'RELOAD';
export const ACCOUNT_INACTIVE = 'ACCOUNT_INACTIVE';


export const GetBalanceSheetData = (param) => {

    return (dispatch) => {
        BalanceSheetService.GetBalanceSheetData(param)
            .then((response) => {
                dispatch({ type: GET_BALANCESHEET_DETAILS, payload: response });
            });
    }
}

export const GetBSAccountsReconcile = (param) => {
    return (dispatch) => {
        BalanceSheetService.GetBSAccountsReconcile(param)
            .then((response) => {
                dispatch({ type: GET_BSACCOUNTS_RECONCILE, payload: response });
            });
    }
}

export const GetArchivedData = (param) => {
    return (dispatch) => {
        BalanceSheetService.GetArchivedBalanceSheet(param)
            .then((response) => {
                dispatch({ type: GET_ARCHIVED_DETAILS, payload: response });
            });
    }
}


export const ArchievedBalanceSheet = (data) => {
    return (dispatch) => {
        BalanceSheetService.ArchievedBalanceSheet(data)
            .then((response) => {
                dispatch({ type: UPDATE_CUSTOM_FILEDS, payload: response });
            });
    }
}


export const UpdateCustomField = (data) => {
    return (dispatch) => {
        BalanceSheetService.UpdateCustomField(data)
            .then((response) => {
                dispatch({ type: UPDATE_CUSTOM_FILEDS, payload: response });
            });
    }
}


export const GetEditArchivedData = (id) => {    
    return (dispatch) => {
        BalanceSheetService.GetArchivedById(id)
            .then((response) => {
                dispatch({ type: GET_EDIT_ARCHIED_DATA, payload: response });
            });
    }
}


export const UpdateArchivedCustomField = (data) => {
    return (dispatch) => {
        BalanceSheetService.UpdateArchivedCustomFields(data)
            .then((response) => {
                dispatch({ type: UPDATE_CUSTOM_FILEDS, payload: response });
            });
    }
}

export const GetLastQuarterGLReviewedDate = (CompanyID) => {
    return (dispatch) => {
        BalanceSheetService.GetLastQuarterGLReviewedDate(CompanyID)
            .then((response) => {
                dispatch({ type: GET_GLReviewLastQueterDate, payload: response });
            });
    }
}

export const PUT_QuickbookAccount_UpdateAccountStatus = (data) => {
    return (dispatch) => {
        return BalanceSheetService.QuickbookAccount_UpdateAccountStatus(data)
            .then((response) => {
                dispatch({ type: ACCOUNT_INACTIVE, payload: response });
                return response;
            })
            .catch((err) => {
                toast.error("Error updating account status");
                throw err;
            });
    };
};

// Same endpoint and body as the Account Reconciliation Review checkbox.
export const PUT_QuickbookAccount_UpdateExcludedReconciliation = (data) => {
    return () => {
        return ReconcillitionService.QuickbookAccount_updatecustomfield(data);
    };
};